import { fetcher } from "@certn/api";

/**
 * Creates a download handler for e-sign document previews.
 * Returns a function that fetches the PDF preview with Bearer auth.
 *
 * The returned function returns the raw Response (not parsed JSON)
 * so the caller can handle the binary PDF data.
 */
export function createESignDownloadHandler(
  caseId: string,
  templateId: string | undefined
): () => Promise<Response> {
  return async () => {
    if (!templateId) {
      throw new Error("Template ID not available for download");
    }
    const token = await fetcher.getAccessToken();
    const url = new URL(
      `/api/internal/applicant/case/${caseId}/agreement-signature/preview/${templateId}/`,
      fetcher.domain
    );

    return fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
  };
}
